module.exports = __webpack_public_path__ + "e3724959bd534f6565d4a56263d60e24.gif";